<template>
  <div class="absolute-center">
  <a href="https://www.youtube.com/@ShareInvestorThailand" target="_blank" class="circle-dazzling">
    <div class="circle-dazzling__text heading">SEE OUR</div>
    <div class="circle-dazzling__text heading-hightlight">Executive Talk!</div>
    <div class="circle-dazzling__icon">
      <i class="icon-arrow-button"></i>
    </div>
  </a>
</div>
</template>

<script setup>
  const localePath = useLocalePath();
</script>

<style lang="scss" scoped>
@import "@/assets/scss/app";

@each $lang in $languages {
  html[lang="#{$lang}"] {
    .circle-dazzling {
      .circle-dazzling__text {
        @include font-size("display-5", $lang);

        &.heading {
          @include font-weight("bold", $lang);
        }
      }
    }
  }
}

.absolute-center{
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.circle-dazzling {

  text-align: center;
  width: 320px;
  height: 320px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: $white;
  border-radius: 50%;
  margin: 2rem auto 0 auto;
  padding-top: 2rem;
  color: $black;

  .circle-dazzling__icon {
    margin-top: 1.25rem;

    i {
      font-size: px-to-rem(26);
    }
  }

  -webkit-animation-duration: 3s;
  animation-duration: 3s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;

  @include hover {
    cursor: pointer;
    animation-name: bounce;
    -moz-animation-name: bounce;
  }
}

@keyframes bounce {
  80% {
    -webkit-transform: translateY(15px);
    -ms-transform: translateY(15px);
    transform: translateY(15px);
  }

  40% {
    -webkit-transform: translateX(15px);
    -ms-transform: translateX(15px);
    transform: translateX(15px);
  }

  60% {
    -webkit-transform: translateY(-15px);
    -ms-transform: translateY(-15px);
    transform: translateY(-15px);
  }

  80% {
    -webkit-transform: translateX(15px);
    -ms-transform: translateX(15px);
    transform: translateX(15px);
  }
}
</style>